const Record = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 4.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15M3.5 12a8.5 8.5 0 1 1 17 0 8.5 8.5 0 0 1-17 0"
      clipRule="evenodd"
    />
    <path fill="currentColor" d="M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0" />
  </>
)
export default Record
